import { Modal } from "react-bootstrap";

export default function InfoModal({ show, onHide, name }) {
	return (
		<Modal show={show} onHide={onHide}>
			<Modal.Header closeButton>
				<Modal.Title className="d-flex align-items-center gap-2">
					<i className="bi bi-info-circle-fill text-info"></i>
					<span className="d-flex align-items-center gap-2">
						Icebreaker Guide
						<img
							src="/images/icebreaker.png"
							alt="Icebreaker icon"
							style={{ width: "28px", height: "28px", objectFit: "contain" }}
						/>
					</span>
				</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<p>
					<i className="bi bi-search my-color"></i> Go and find{" "}
					<strong className="text-primary">{name || "this person"}</strong> and break the ice by asking them the
					question below!
				</p>

				<hr />

				<div className="mt-3">
					<p className="text-muted small">
						You can change the <strong className="text-primary">language</strong> and{" "}
						<strong className="text-primary">subject</strong>
					</p>
					<p className="text-muted small">
						using the settings icon <i className="bi bi-gear-fill my-color"></i>
					</p>
				</div>
			</Modal.Body>
		</Modal>
	);
}
